import clsx from "clsx";
import {
  getTotalByTransactionType,
  rgbaObjectToString,
} from "../../helpers/utils";
import useCurrentAccount from "../../hooks/useCurrentAccount";
import BankCard from "../BankCard/BankCard";
import { useTranslation } from "react-i18next";
import { ETransactionType, ICON_SIZES } from "../../helpers/constants";
import { MdOutlineCompareArrows, MdShare } from "react-icons/md";
import useModalsStore from "src/store/modalsStore";
import { useNavigate } from "react-router-dom";

const CurrentAccountCard: React.FC = () => {
  const { currentAccountData } = useCurrentAccount();
  const { t } = useTranslation();
  const { activeTransactions } = useCurrentAccount();
  const { setShowMoneyTransferModal } = useModalsStore();
  const navigate = useNavigate();

  const getAvailableMoney = () => {
    const income = getTotalByTransactionType({
      type: ETransactionType.INCOME,
      transactions: activeTransactions,
    });
    const expenses = getTotalByTransactionType({
      type: ETransactionType.EXPENSE,
      transactions: activeTransactions,
    });

    return income - expenses;
  };

  return (
    <>
      <BankCard
        name={currentAccountData?.name}
        owner={currentAccountData?.owner}
        bank={currentAccountData?.bank}
        number={currentAccountData?.number}
        customStyles={{
          background: rgbaObjectToString({
            ...(currentAccountData?.settings?.bg || { r: 0, g: 0, b: 0 }),
            a: 1,
          }),
          color: rgbaObjectToString({
            ...(currentAccountData?.settings?.color || { r: 0, g: 0, b: 0 }),
            a: 1,
          }),
        }}
        onTitleClick={() => {
          navigate(`/settings/accounts/${currentAccountData?.account}`);
        }}
        actions={[
          {
            onClick: () => setShowMoneyTransferModal(true),
            icon: <MdOutlineCompareArrows size={ICON_SIZES.MD} />,
            tooltip: t("common_tooltips.transfer_funds"),
            className: clsx([
              "!bg-transparent",
              "!text-current",
              "md:!h-[40px]",
              "md:!w-[40px]",
              "md:!max-w-[40px]",
              "md:!min-w-[40px]",
              "md:!max-h-[40px]",
              "md:!min-h-[40px]",
              "!border-0",
              "!shadow-none",
            ]),
          },
          {
            hide: [
              !!currentAccountData?.number,
              !!currentAccountData?.bank,
            ].includes(false),
            icon: <MdShare size={ICON_SIZES.MD} />,
            onClick: async (e: any) => {
              e?.preventDefault();
              await navigator
                .share({
                  text: [
                    currentAccountData?.name,
                    `Banco: ${currentAccountData?.bank || "Desconocido"}`,
                    `Número de cuenta: ${
                      currentAccountData?.number || "Desconocido"
                    }`,
                    `Moneda: ${currentAccountData?.currency || "Desconocida"}`,
                  ].join("\n"),
                })
                .then((a) => {})
                .catch((e) => {});
            },
            tooltip: t("common_tooltips.share"),
            className: clsx([
              "!bg-transparent",
              "!text-current",
              "md:!h-[40px]",
              "md:!w-[40px]",
              "md:!max-w-[40px]",
              "md:!min-w-[40px]",
              "md:!max-h-[40px]",
              "md:!min-h-[40px]",
              "!border-0",
              "!shadow-none",
            ]),
            disabled: !currentAccountData?.number,
          },
        ]}
        account={currentAccountData?.account}
        variant="custom"
        currency={currentAccountData?.currency}
        available={getAvailableMoney()}
      />
    </>
  );
};

export default CurrentAccountCard;
